import { useState } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Popover } from 'foundations-components/transitional/components/Popover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function AssociationsSortMoreButton({
  selectMenu
}) {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenChange = e => {
    setIsOpen(e.currentTarget.value);
  };
  const handleClick = () => {
    setIsOpen(prevOpen => !prevOpen);
  };
  const renderMoreButtonText = () => /*#__PURE__*/_jsx(Text, {
    as: "h7",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.AssociatedObjectsActionBar.more"
    })
  });
  return /*#__PURE__*/_jsx(Popover, {
    open: isOpen,
    onOpenChange: handleOpenChange,
    use: "default",
    placement: "bottom left",
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.AssociatedObjectsActionBar.moreFilters"
        })
      }),
      body: /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "500",
        children: selectMenu
      })
    },
    children: /*#__PURE__*/_jsx("div", {
      onClick: handleClick,
      "data-test-id": "more-select-button-wrapper",
      children: /*#__PURE__*/_jsx(Select, {
        multi: false,
        anchorType: "button",
        buttonUse: "unstyled",
        buttonSize: "medium",
        open: false,
        ButtonContent: renderMoreButtonText
      })
    })
  });
}
export default AssociationsSortMoreButton;